<template>
    <div id="sign">
        <div class="container">
            <div class="row">
                <div class="rowDetail">
                    <span class="goPage sbxs">
                        <router-link tag="div" :to="{ path: '/login' }"><a-icon type="left" style="font-size: 14px"/></router-link>
                    </span>
                    <p style="margin: 14px 0;">{{ $t('login.VerificationAddress') }}</p>
                    <a-form :form="form">
                        <a-form-item>
                            <a-input size="large" :placeholder="$t('login.EmailAddress')"
                                 v-decorator="[
                                     'EmailAddress',
                                      { rules: [{
                                          pattern: RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$'),
                                          required: true,
                                           message: $t('userlang.EmailInfoFrom')
                                      }] }
                                 ]"/>
                        </a-form-item>
                        <a-form-item>
                            <a-input autocomplete="off"  style="margin-top: 14px;" size="large" :placeholder="$t('login.VerificationCode')"
                                 v-decorator="[
                                 'emailCaptcha',
                                      { rules: [{
                                          required: true,
                                           message: $t('login.Pleaseverification')
                                      }] }
                                 ]"/>
                        </a-form-item>
                        <a-row style="margin: 14px 0">
                            <a-button type="primary" size="large" @click="sendEmail" :disabled="!timeVis" id="loginBtnSign">
                                <span v-if="timeVis">{{ $t('login.Sendverification') }}</span>
                                <span v-else style="color: #fff;">{{count}}s</span>
                            </a-button>
                        </a-row>
                        <a-row>
                            <a-input size="large" :style="{borderColor: fromData.infoErrorTop ? 'red' : '#d9d9d9'}" :placeholder="$t('login.NewPassword')" type="password" v-model="fromData.TpassWord" @change="changeIputPassT"/>
                            <div class="infoError" v-if="fromData.infoErrorTop">{{ $t('login.passWordError1') }}<br>{{ $t('login.passWordError2') }}<br>&nbsp;&nbsp;{{$t('login.passWordError3')}}<br>&nbsp;&nbsp;{{$t('login.passWordError4')}}<br>&nbsp;&nbsp;{{ $t('login.passWordError5') }}<br>&nbsp;&nbsp;{{ $t('login.passWordError6') }}</div>
                        </a-row>
                        <a-form-item style="margin: 14px 0">
                            <a-input
                                :placeholder="$t('login.ConfirmNewPassword')"
                                size="large"
                                v-decorator="[
                                      'confirm',
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: $t('login.PleaseConfirmPassword'),
                                          },
                                          {
                                            validator: compareToFirstPassword,
                                          },
                                        ],
                                      },
                                    ]"
                                type="password"
                                @blur="handleConfirmBlur"
                            />
                        </a-form-item>
                    </a-form>
                    <a-button id="loginBtnSign"  style='margin-top: 14px;' type="primary" size="large" @click="createFrom" :loading="CreateLoading">{{ $t('login.Create') }}</a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    export default{
        data(){
            return{
                form: this.$form.createForm(this), // 表单
                timeVis: true,
                count: null,
                confirmDirty: false, // 密码保持一致所需要
                fromData:{
                    TpassWord: undefined,
                    infoErrorTop: false,
                },
                CreateLoading: false
            }
        },
        watch:{
            $route(){
                this.form.resetFields();
                this.fromData = {
                    TpassWord: undefined,
                    infoErrorTop: false,
                }
            }
        },
        methods:{
//            密码保持一致
            handleConfirmBlur(e) {
                const value = e.target.value;
                this.confirmDirty = this.confirmDirty || !!value;
            },
//            密码保持一致
            compareToFirstPassword(rule, value, callback) {
                const form = this.form;
                let val = this.fromData.TpassWord
                if (value && value !== val) {
                    callback(this.$t('login.TwopasswordsInconsistent'));
                } else {
                    callback();
                }
            },
//            发送验证码
            sendEmail(){
                let val = this.form.getFieldValue('EmailAddress')
                let pattern = new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$")
                if(pattern.test(val)){
                    this.timeVis = false
                    ajax.get(api.USERSENDEMAIL,{email: val}).then(res=>{})
                    this.count = 60;
                    this.timer=setInterval(() => {
                        this.count--;
                        if(this.count<=0){
                            clearInterval(this.timer);
                            this.timeVis = true
                        }
                    },1000);
                }
            },
//            密码正则
            changeIputPassT(){
                if(this.fromData.TpassWord == ''){
                    this.fromData.infoErrorTop = false
                    return
                }

                let pattern = new RegExp(/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/)
                this.form.validateFields(['confirm'], { force: true }); // 实事校验密码保持一致
                if(pattern.test(this.fromData.TpassWord)){
                    this.fromData.infoErrorTop = false
                }else{
                    this.fromData.infoErrorTop = true
                }
            },
//            提交
            createFrom(){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let pattern = new RegExp(/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/)
                        if(pattern.test(this.fromData.TpassWord)){
                            this.fromData.infoErrorTop = false
                            let params = {
                                "emailCaptcha": values.emailCaptcha,
                                "password": this.fromData.TpassWord,
                                "username": values.EmailAddress
                            }
                            this.CreateLoading = true
                            ajax.post(api.USERSIGNUP,params).then(res=>{
                                this.CreateLoading = false
                                if(res.code == 200){
                                    this.$message.success(this.$t('login.RegistrationSuccess'));
                                    this.$router.push({path: "/login"})
                                }else if(res.code == 501){
                                    this.$customMessage.warning(this.$t('login.UserAlreadyExist'));
                                }else if(res.code == 502) {
                                    this.$customMessage.warning(this.$t('login.CaptchaError'));
                                }else{
                                        this.$customMessage.warning(res.msg);
                                    }
                            })
                        }else{
                            this.fromData.infoErrorTop = true
                        }
                    }
                });
            }
        }
    }
</script>
<style lang="less">
    #sign{
        background: url("../../assets/img/dabg.png");
    }
    .infoError{
        font-size: 12px;
        color: #f5222d;
        text-align: left;
    }
    .container {
        text-align: center;
        width: 100%;
        display: table;
        height: 100vh;
        padding: 0;
        .row {
            width: 100%;
            margin: 0;
            display: table-cell;
            vertical-align: middle;
            .ant-form-explain{
                text-align: left;
            }
            .rowDetail{
                width: 470px;
                margin: 0 auto;
                background: white;
                /*height: 65vh;*/
                position: relative;
                padding: 40px 40px;
                .goPage{
                    position: absolute;
                    top: 25px;
                    left: 25px;
                }
                .logo{
                    width: 70px;
                    height: 70px;
                }
            }
        }
    }

</style>